import { useActivityEntity } from 'src/hooks/useEntity'
import { AdaptiveEngineSelectionGroupEntity } from 'src/models/dto/activities/AdaptiveEngineSelectionGroupDTO'

export function useAdaptiveEngineEntity(props: {
    workflowEntityId: string
    moduleEntityId: string
}) {
    return useActivityEntity<AdaptiveEngineSelectionGroupEntity>(props)
}
